export function uuid() {
    let _p8 = s => {
        let p = (Math.random().toString(16) + '000000000').substr(2, 8);
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
    };
    return _p8() + _p8(true) + _p8(true) + _p8();
}

export function isSomeParent(domElement, callback) {
    let parent = domElement;
    while (parent) {
        if (callback(parent)) {
            return true;
        }
        parent = parent.parentElement;
    }
    return false;
}

export function getErrorMessage(errorObject) {
    if (typeof errorObject.error === 'string') {
        return errorObject.error;
    }

    if (errorObject.error && errorObject.error.code === 101) {
        return errorObject.error.message;
    }

    return JSON.stringify(errorObject);
}

export function getFilterMembersCallback(query) {
    const filter = query.toUpperCase();
    return function(member) {
        return (
            (member.email && member.email.toUpperCase().includes(filter)) || // email not available in inital pass
            member.firstName.toUpperCase().includes(filter) ||
            member.lastName.toUpperCase().includes(filter) ||
            `${member.firstName} ${member.lastName}`
                .toUpperCase()
                .includes(filter)
        );
    };
}

export function isValidEmail(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    return regex.test(String(email).toLowerCase());
}

export function isValidTag(tag) {
    const regex = /^[0-9a-zA-Z_\s-]+$/;
    return regex.test(tag);
}



// WEBPACK FOOTER //
// ./src/helpers/Util.js